import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-styles',
	templateUrl:'./FontAwesomeStylesPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeStylesPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeStylesPluginCompPage
{
	mdContent_957 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.options.FontAwesomeStyles;
\`\`\``;
}
